import {
  type ForwardedRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react'

import { FvButton } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { ValidatedForm } from './inputs'
import { InputAdornment, InputGroup } from './inputs/InputGroup'

type Props = PropsWithClassName<{
  initialValue?: string
  onChange: (value: string) => void
  isLoading?: boolean
  name: string
  placeholder?: string
  autoFocus?: boolean
}>

export type SearchFormHandle = {
  setValue: (value: string) => void
}
export const SearchForm = forwardRef(
  (
    {
      initialValue,
      isLoading,
      onChange,
      className,
      name,
      placeholder,
      autoFocus,
    }: Props,
    ref: ForwardedRef<SearchFormHandle>,
  ) => {
    const [value, setValue] = useState(initialValue ?? '')

    const handleSubmit = () => {
      onChange(value)
    }

    useImperativeHandle(ref, () => ({
      setValue: (newValue: string) => {
        setValue(newValue)
        onChange(newValue)
      },
    }))
    return (
      <ValidatedForm onValidSubmit={handleSubmit}>
        <InputGroup
          className={className}
          endContent={
            <InputAdornment position="end">
              <FvButton
                loading={isLoading}
                theme="search"
                type="submit"
                icon="search"
              >
                Search
              </FvButton>
            </InputAdornment>
          }
          inputType="text"
          inputProps={{
            value,
            onChange: e => setValue(e.target.value),
            name,
            placeholder,
            autoFocus,
          }}
        ></InputGroup>
      </ValidatedForm>
    )
  },
)
